import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import PhoneIcon from '@mui/icons-material/Phone'
import YoutubeIcon from '@mui/icons-material/YouTube'
import { Box, Container, Grid, Link, Stack, Typography } from '@mui/material'
import logoImage from '../../assets/logo-footer.webp'

const pages = ['Home', '¿Quienes somos?', 'Contacto']

const LinkEffects = {
  opacity: '.75',
  transition: '.3s',
  fontWeight: 500,
  color: '#1b3458',
  ':hover': {
    color: '#89161a',
  },
}

export const Footer = () => {
  return (
    <div
      style={{
        position: 'relative',
        bottom: 0,
        left: 0,
        width: '100%',
        height: 'auto',
        minHeight: 220,
        backgroundColor: 'rgb(169 169 169)',
      }}
    >
      <Container style={{ position: 'relative', textAlign: 'left', paddingTop: 5, paddingBottom: 5 }}>
        <Grid container>
          <Grid item xs={12} sm={2} md={2} textAlign="center">
            <Grid item xs={12}>
              <Box component='img' src={logoImage} sx={{ width: { xs: 100, md: '80%' } }} alt="RH Empresa & Personas" />
              <Typography
                textAlign="center"
                sx={{
                  fontSize: 10,
                }}
              >
                RH EMPRESA &
              </Typography>
              <Typography
                textAlign="center"
                sx={{
                  fontSize: 14,
                  color: '#89161a',
                }}
              >
                Personas
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                <Grid item>
                  <Link href="#">
                    <InstagramIcon fontSize="medium" sx={LinkEffects} />
                  </Link>
                </Grid>
                <Grid item>
                  <Link href="#">
                    <FacebookIcon fontSize="medium" sx={LinkEffects} />
                  </Link>
                </Grid>
                <Grid item>
                  <Link href="#">
                    <YoutubeIcon fontSize="medium" sx={LinkEffects} />
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={10} md={10} sx={{ display: { xs: 'none' } }}>
            <Grid
              container
              spacing={4}
              direction="row-reverse"
              justifyContent="flex-start"
              sx={{
                mt: 1,
              }}
            >
              <Grid item>
                <Grid container spacing={2} direction="column" justifyContent="flex-start" alignItems="left">
                  <Grid item>
                    <Typography fontWeight="bold" color="gray">
                      ¿Donde estamos?
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Stack direction="row" alignItems="center" gap={1}>
                      <LocationOnIcon sx={{ color: '#89161a' }} />
                      <Typography variant="body1">Km 123, Ciudad del Est - PY</Typography>
                    </Stack>
                  </Grid>
                  <Grid item>
                    <Stack direction="row" alignItems="center" gap={1}>
                      <PhoneIcon sx={{ color: '#89161a' }} />
                      <Typography variant="body1">(xxx) xxx xxx</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid container spacing={2} direction="column" justifyContent="flex-start" alignItems="left">
                  <Grid item>
                    <Typography fontWeight="bold" color="gray">
                      Institucional
                    </Typography>
                  </Grid>
                  {pages.map((page, index) => (
                    <Grid item key={index}>
                      <Link href="#" sx={{ ...LinkEffects, textTransform: 'uppercase', fontSize: 12 }} underline="none">
                        {page}
                      </Link>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={10} md={10} sx={{ display: { xs: 'block', sm: 'none' } }}>
            <Grid
              container
              spacing={4}
              direction="column"
              justifyContent="center"
              sx={{
                mt: 1,
              }}
            >
              <Grid item>
                <Grid container spacing={2} direction="column" justifyContent="flex-start" alignItems="left">
                  <Grid item>
                    <Typography fontWeight="bold" color="gray">
                      ¿Donde estamos?
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Stack direction="row" alignItems="center" gap={1}>
                      <LocationOnIcon sx={{ color: '#89161a' }} />
                      <Typography variant="body1">Km 123, Ciudad del Est - PY</Typography>
                    </Stack>
                  </Grid>
                  <Grid item>
                    <Stack direction="row" alignItems="center" gap={1}>
                      <PhoneIcon sx={{ color: '#89161a' }} />
                      <Typography variant="body1">(xxx) xxx xxx</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid container spacing={2} direction="column" justifyContent="flex-start" alignItems="left">
                  <Grid item>
                    <Typography fontWeight="bold" color="gray">
                      Institucional
                    </Typography>
                  </Grid>
                  {pages.map((page, index) => (
                    <Grid item key={index}>
                      <Link href="#" sx={{ ...LinkEffects, textTransform: 'uppercase', fontSize: 12 }} underline="none">
                        {page}
                      </Link>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Typography variant="subtitle1" sx={{ color: 'white', fontSize: 12 }}>
              © 2024 RH Empresa & Personas - Grupo RH Empresa
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default Footer
